export const isScmQuoteOnlyTitle = (title: string | undefined): boolean =>
  typeof title === "string" && title.toUpperCase().includes("SCM");